import { API_ROUTES } from "../config/baseURL";
import request from "./clientsApi";

const sedeApi = {
    getAll: () =>
        request(API_ROUTES.sedes).then((r) => r.json()),

    save: (data) =>
        request(API_ROUTES.sede, {
            method: data.id ? "PUT" : "POST",
            body: JSON.stringify(data),
        }).then((r) => r.json()),

    getByUsuario: (idUsuario) =>
        request(`${API_ROUTES.usuarioSede}?id_usuario=${idUsuario}`).then((r) => r.json()),

    asignar: (idUsuario, idSede) =>
        request(API_ROUTES.usuarioSedeAsignar, {
            method: "POST",
            body: JSON.stringify({ id_usuario: idUsuario, id_sede: idSede }),
        }).then((r) => r.json()),

    quitar: (id) =>
        request(API_ROUTES.usuarioSedeQuitar, {
            method: "POST",
            body: JSON.stringify({ id }),
        }).then((r) => r.json()),
};

export default sedeApi;
